import "./index.css";

import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { client } from "./api/client.gen";
import { App } from "./App";
import { getAppConfig } from "./config/get-app-config.ts";
import { initAuthedApi } from "./utils/authed-client";

const appConfig = getAppConfig();
initAuthedApi(client);

if (appConfig.envMode === "production") {
  Sentry.init({
    dsn: appConfig.sentryDsn,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
